import { prop, compose } from 'ramda';

import { selectedProduct } from 'app/features/products/selectors';

const billing = prop('billing');

const selectedPlan = compose(prop('selectedPlan'), billing);

const selectedPlanSku = compose(prop('sku'), selectedPlan);

const isBillingPlanSelected = compose(Boolean, selectedPlan);

const subscriptionTitleKey = compose(
  prop('subscriptionTitleKey'),
  selectedProduct,
);

export {
  selectedPlan,
  isBillingPlanSelected,
  selectedPlanSku,
  subscriptionTitleKey,
};
